'use client';

import { type PropsWithChildren } from 'react';
import { FaPlus } from 'react-icons/fa6';

import { Button } from '@/components/Button';
import * as Dialog from '@/components/Dialog';

import { Partner } from '../types';

export type PartnerDetailsModalProps = PropsWithChildren<{
  partner: Partner;
}>;

export function PartnerDetailsModal({
  partner,
  children,
}: PartnerDetailsModalProps) {
  return (
    <Dialog.Root>
      <Dialog.Trigger>{children}</Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay />

        <Dialog.Content>
          <Dialog.Title>{partner?.name}</Dialog.Title>

          <Dialog.ContentHeader>
            <Dialog.Close asChild>
              <Button
                className="absolute top-4 left-4 rounded-full bg-white shadow-md"
                variant="ghost"
              >
                <FaPlus className="size-4 rotate-45" />
              </Button>
            </Dialog.Close>

            <p className="self-center text-xl font-normal">{partner?.name}</p>
          </Dialog.ContentHeader>

          <Dialog.ContentBody>
            <p className="p-5 text-lg whitespace-pre-line md:p-6">
              {partner?.description}
            </p>
          </Dialog.ContentBody>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
